// Novidades para quem usa o Gestão (não é changelog: as notas técnicas ficam na Release do GitLab).
// A cada versão: uma entrada nova NO TOPO, com os destaques escritos à mão e as fotos em public/novidades/<versão>/.
// Os números em `pins` são os círculos laranja desenhados na foto. Fotos só do ambiente de demonstração (dados fictícios).
export const NOVIDADES = [
  {
    version: 'v1.0.0',
    date: '2026-11-04',
    items: [
      { img: 'abas', title: 'O chamado agora tem abas', lead: 'A conversa com o cliente fica separada do que é só da equipe.',
        pins: ['Conversa, Atividade e SLA: cada coisa no seu lugar.',
               'As notas internas aparecem resumidas no meio da conversa. Clique para ver.',
               'Na Conversa, o que você escreve vai para o cliente.'] },
      { img: 'atividade', title: 'Atividade: tudo o que aconteceu, em ordem', lead: 'Notas internas e mudanças do chamado, com quem fez cada uma.',
        pins: ['Nota que você ainda não leu aparece marcada como nova.',
               'Quando o dev corrige no GitLab, a correção aparece aqui.',
               'Cada mudança mostra quem fez: “Admin passou o chamado para Maria”.'] },
      { img: 'sla', title: 'Prazo sempre à vista', lead: 'Você sabe quanto falta sem abrir nada.',
        pins: ['O prazo mais próximo fica no topo da lateral.',
               'A aba SLA ganha um ponto amarelo ou vermelho quando o prazo aperta.',
               'Na aba, os prazos de 1ª resposta e resolução, e o tempo em cada etapa.'] },
      { img: 'observador', title: 'Observadores', lead: 'Passou o chamado para outra pessoa? Você continua acompanhando.',
        pins: ['Quem passa o chamado vira observador. Dá para sair em “Deixar de observar”.',
               'O observador lê tudo e escreve nota interna, mas não responde ao cliente.'] },
      { img: 'observando', title: 'Meus chamados e Observando', lead: 'No quadro e na lista, escolha o que quer ver.',
        pins: ['“Meus chamados” é a sua fila. “Observando” mostra os que você acompanha, com o número de novidades.'] },
      { img: 'gitlab', narrow: true, title: 'Issue no GitLab', lead: 'Abra a issue para o dev direto do chamado e acompanhe a correção.',
        pins: ['A lateral mostra a issue e em que pé está: com o dev, corrigida, aguardando deploy.'] },
      { img: 'tipo', narrow: true, title: 'Novo tipo: Dúvida', lead: 'Além de Problema e Melhoria, agora existe Dúvida.',
        pins: ['Mude o tipo aqui. Dúvida não abre issue no GitLab.'] },
    ],
    also: [
      'Você continua logado por 30 dias, até clicar em Sair.',
      'Se uma resposta não chegar ao cliente, o chamado avisa e você reenvia com um clique.',
      'O quadro troca entre Meus chamados e Observando mais rápido, com cards de carregamento.',
      'Marca nova do Gestão, e a versão no ar aparece no login.',
    ],
  },
]

import { ref } from 'vue'

export const ULTIMA = NOVIDADES[0]
// Abrir de novo pelo menu do perfil (a janela só abre sozinha quando a versão ainda não foi vista).
export const newsOpen = ref(false)
export const foto = (version, img) => `/novidades/${version}/${img}.png`
